module.exports = __webpack_public_path__ + "img/engravingRingsize-1@2x.bb9e31b.webp";